import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { images } from '../../data/images';
import { store } from '../../data/store';
import { PermanenceWeek } from './PermanenceWeek';
export function ConceptTeaser() {
  return <section className="mx-auto max-w-[1440px] px-5 py-16 md:px-8 md:py-24" aria-labelledby="concept-title" data-id="element-285" data-mp="gj1jqeqi8dce">
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-286" data-mp="1e6idfoboo3j9">
        <div className="lg:col-span-6" data-id="element-287" data-mp="1e60hkssxnrbv">
          <div className="aspect-[4/5] overflow-hidden rounded-sm bg-shell md:aspect-[3/2] lg:aspect-[4/5]" data-id="element-288" data-mp="197yrhnx3arqw">
            <img src={images.workshop} alt="Mains d’un potier façonnant une pièce sur le tour" loading="lazy" className="h-full w-full object-cover" data-id="element-289" data-mp="147t4wm5ofvfo" />
          </div>
        </div>
        <div className="flex flex-col justify-center lg:col-span-6" data-id="element-290" data-mp="3oyl8b0g8d7l4">
          <h2 id="concept-title" className="font-display text-4xl leading-[1.02] md:text-6xl" data-id="element-291" data-mp="3owqlfglef5ee">
            Ici, ce sont <em className="text-clay" data-id="element-292" data-mp="3k236o9g75pd0">les créateurs</em> qui vous accueillent.
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-muted" data-id="element-293" data-mp="1mxpo1aur1s8m">
            Pas de vendeurs : les créateurs exposés assurent la boutique à tour de rôle. Venez poser vos questions à celle
            qui a tourné le vase ou à celui qui a cousu le sac — et retirez vos commandes en ligne de leurs mains.
          </p>
          <div className="mt-10" data-id="element-294" data-mp="149kpqiwv2zh7">
            <div className="mb-3 flex items-baseline justify-between" data-id="element-295" data-mp="148j2zh6hgojn">
              <h3 className="text-sm font-medium" data-id="element-296" data-mp="190j9xtkz0hpq">Qui tient la boutique cette semaine</h3>
              <span className="text-xs text-muted" data-id="element-297" data-mp="ubde8flcd9ml">{store.hours[0].time}</span>
            </div>
            <PermanenceWeek data-id="element-298" data-mp="z9yegf0lftb1" />
          </div>
          <Link to="/concept" className="group mt-8 inline-flex items-center gap-2 self-start text-sm font-medium" data-id="element-299" data-mp="zazr2nx9cnuv">
            <span className="border-b border-ink/30 pb-0.5 group-hover:border-ink" data-id="element-300" data-mp="lb8f0sqaxhji">Comprendre le concept</span>
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-301" data-mp="pe4ptx9lo9cw" />
          </Link>
        </div>
      </div>
    </section>;
}